<template>
  <div class="cart" id="carrinho_compras">
    <section v-if="loading" class="loading">
      <div class="
          align-items-center
          d-flex
          flex-column
          h-100
          justify-content-center
          text-white
        ">
        <h4 class="px-4">Processando seu carrinho de compras</h4>
        <div class="spinner-grow" style="width: 3rem; height: 3rem">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </section>
    <div class="caixa_carrinho mb-2">
      <span class="titulo_carrinho">
        <img src="https://pagglo-cdn.s3.amazonaws.com/app/rede/ifly/ico-carrinho.svg" />
        Carrinho
      </span>
      <div class="align-items-end
          d-flex
          flex-column
          h-100
          justify-content-center
          text-white" v-if="this.$store.state.pedido.itens.length !== 0">
        <button @click="excluirItensPedido()" class="btn btn-sm p-1">
          Limpar Carrinho
          <!-- <img src="https://pagglo-cdn.s3.amazonaws.com/app/rede/ifly/ico-apagar.svg" /> -->
        </button>
      </div>

      <div class="box_carrinho mt-3">
        <div class="
            carrinho_vazio
            d-flex
            justify-content-center
            align-items-center
            flex-column
          " v-if="this.$store.state.pedido.itens.length === 0">
          <img :src="carrinhoVazio" style="width: 80px; margin: 20px" />
          <span>Seu carrinho está vazio.</span>

        </div>

        <div class="carrinho_cheio" v-else>
          <div class="
              item_venda
              my-3
              d-flex
              justify-content-center
              align-items-center
              flex-row flex-wrap flex-md-nowrap
            " v-for="(item, index) of this.$store.state.pedido.itens" :key="index">
            <div class="d-flex mb-3 w-100">
              <div class="cat_relogio">
                <img :src="imagemPrincipal(item.produto.imagemList)" />
              </div>
              <div class="descricao d-flex align-self-start flex-column">
                <span class="item_selecao" v-if="item.produto">
                  {{ item.produto.nome }}
                  <br />
                </span>
                <small style="color: #757575">
                  Vendido por:
                  <strong>{{
                    item && item.produto && item.produto.redeLoja
                    ? item && item.produto && item.produto.redeLoja.nome
                    : ""
                  }}
                  </strong>
                </small>
                <div v-for="(modificador, i) in item.produto
                  .categoriaModificadorList" :key="i" class="py-2">
                  <span v-for="(
                      modificadorItem, index
                    ) in modificador.produtoModificadorList" :key="index">
                    {{ modificador ? modificador.nome : "" }}:
                    {{ modificadorItem ? modificadorItem.nome : "" }}
                  </span>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <div class="align-items-center d-flex flex-column">
                <div class="custom-input-number d-flex align-items-center">
                  <button type="button" @click="adicionar(false, item)" :disabled="item.quantidade === 1">
                    -
                  </button>
                  <span class="px-3">{{ item.quantidade }}</span>
                  <button type="button" @click="adicionar(true, item)">
                    +
                  </button>
                </div>
                <small @click="excluirItem(item.id, 0, item.produto)" class="btn btn-sm p-1">
                  remover
                  <!-- <img src="https://pagglo-cdn.s3.amazonaws.com/app/rede/ifly/ico-apagar.svg" /> -->
                </small>
              </div>
              <div class="item_valor pl-4 pr-3" style="font-size: 1rem">
                {{
                  (item.quantidade > 0
                    ? item.quantidade *
                    (item.produto.valorUnitario + calcAdicional(item.produto))
                    : 0) | currency
                }}
              </div>
              <div class="opcoes p-3">
                <span @click="detailsProduct(item)">
                  <img src="https://pagglo-cdn.s3.amazonaws.com/app/rede/ifly/ico-editar.svg" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="check_out mt-4" v-if="this.$store.state.pedido.itens.length > 0">
        <div class="total d-flex justify-content-betwen align-items-center" v-if="this.$store.state.pedido && this.$store.state.pedido.itens[0]
          && this.$store.state.pedido.itens[0].pedido && this.$store.state.pedido.itens[0].pedido.cupom">
          <span class="quantidade">Cupom Utilizado <b>
              {{ this.$store.state.pedido.itens[0].pedido.cupom?.codigoCupom }}</b> {{
                this.$store.state.pedido.itens[0].pedido.cupom?.valorDesconto * 100 }}{{
    this.$store.state.pedido.itens[0].pedido.cupom.premiacaoTipo === 'PERCENTUAL_DESCONTO' ? '%' : '' }}
            de desconto
          </span>
        </div>
        <div class="total d-flex justify-content-betwen align-items-center" v-if="this.$store.state.pedido.valorFrete">
          <span class="quantidade">Valor Frete</span>
          <div class="align-items-end d-flex flex-column ml-auto">
            <span class="valor">
              {{ this.$store.state.pedido.valorFrete | currency }}
            </span>
          </div>
        </div>
        <div class="total d-flex justify-content-betwen align-items-center">
          <span class="quantidade">Desconto</span>
          <div class="align-items-end d-flex flex-column ml-auto">
            <span class="valor">
              {{ this.$store.state.pedido.valorDesconto | currency }}
            </span>
          </div>
        </div>

        <div class="total d-flex justify-content-betwen align-items-center">
          <span class="quantidade">Total ({{ this.somaItens() }})</span>
          <div class="align-items-end d-flex flex-column ml-auto">
            <span class="valor">
              {{ this.$store.state.pedido.valorTotal | currency }}
            </span>
          </div>
        </div>

        <button class="btn_fecharpedido" @click="fecharPedido()">
          Finalizar compra
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { APIService } from "../APIService";
const apiService = new APIService();

export default {
  name: "Cart",
  data() {
    return {
      objDetalhes: { idProduto: 0, quantidade: 0, objProduto: {} },
      carrinhoVazio: `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='23.625' height='21' viewBox='0 0 23.625 21'%3E%3Cpath id='ico-carrinho' d='M21.661,12.359,23.6,3.828a.984.984,0,0,0-.96-1.2H6.53L6.154.787A.984.984,0,0,0,5.19,0H.984A.984.984,0,0,0,0,.984v.656a.984.984,0,0,0,.984.984H3.851L6.732,16.711a2.3,2.3,0,1,0,2.75.351h8.6a2.3,2.3,0,1,0,2.609-.427l.226-1a.984.984,0,0,0-.96-1.2H8.946l-.268-1.313H20.7A.984.984,0,0,0,21.661,12.359Z' fill='%23CCC'/%3E%3C/svg%3E`,
      valorTotal: 0,
      loading: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    adicionar(add, item) {
      this.loading = true;
      const action = add ? "pedidoAdicionarProduto" : "pedidoRemoverProduto";
      const tempItem = {
        produto: item.produto,
        quantidade: 1,
      };

      this.$store.dispatch(action, tempItem);

      setTimeout(() => {
        let token = localStorage.getItem("accessToken");

        if (!this.$store.state.user && token) {
          this.atualizarItensCarrinhoByToken(this.$store.state.pedido, token);
        } else {
          if (!this.$store.state.user) {
            if (!this.$store.state.user) {
              this.loading = false;

              return;
            }
          }

          this.atualizarItensCarrinho(this.$store.state.pedido);
        }
      }, 500);
    },
    imagemPrincipal(list) {
      if (!list || list.length === 0) {
        return "https://pagglo-cdn.s3.amazonaws.com/app/assets/sem_foto.png";
      }

      const item = list.find((o) => o.imagemPrincipal);

      return item && list && list.length
        ? item.urlImagem || list[0].urlImagem
        : "https://pagglo-cdn.s3.amazonaws.com/app/assets/sem_foto.png";
    },
    somaItens() {
      let soma = 0;
      this.$store.state.pedido.itens.forEach((o) => (soma += o.quantidade));
      return soma;
    },
    somaPontos() {
      let soma = 0;
      this.$store.state.pedido.itens.forEach(
        (o) => (soma += o.produto.pontos * o.quantidade)
      );
      return soma;
    },
    descricaoCurta(desc) {
      return desc ? desc.replace(/<.+?>/gm, "").replace(/\n/gm, " - ") : "";
    },
    fecharPedido() {
      this.$router.push(`/carrinho`);
    },
    excluirItem(itemId, quantidade, produto) {
      this.loading = true;

      let token = localStorage.getItem("accessToken");

      if (!this.$store.state.user && !token) {
        this.loading = false;
        this.$store.dispatch("pedidoApagarProduto", produto.id);
        return;
      }

      apiService
        .excluirItemPedido(itemId, quantidade, this.$store.state.pedido)
        .then((response) => {
          this.loading = false;
          if (response) {
            this.setPedidoToLocalStorage(response);
          }
        })
        .catch((error) => {
          this.loading = false;
          if (error && error.response) {
            this.freteError = error.response.data.title;
          }
        })
        .finally(() => {
          this.loadingCalcularFrete = false;
        });
    },

    excluirItensPedido() {
      this.$swal({
        title: "Tem certeza que deseja limpar o carrinho? Todos os produtos serão removidos!",
        confirmButtonText: "Ok",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        preConfirm: () => {
          let token = localStorage.getItem("accessToken");
          let produto;
          this.loading = true;
          if (!this.$store.state.user && !token) {
            this.loading = false;
            this.$store.state.pedido.itens.forEach(item => {
              produto = item.produto;
              this.$store.dispatch("pedidoApagarProduto", produto.id);
          });
            return;
          }
          let itensId = [];
          this.$store.state.pedido.itens.forEach(item => {
            itensId.push(item.id);
          });
          apiService
            .excluirPedido(itensId, this.$store.state.pedido)
            .then((response) => {
              this.loading = false;
              if (response) {
                this.setPedidoToLocalStorage(response);
              }
            })
            .catch((error) => {
              this.loading = false;
              if (error && error.response) {
                this.freteError = error.response.data.title;
              }
            })
            .finally(() => {
              this.loadingCalcularFrete = false;
            });
        }
      });
    },
    detailsProduct(produto) {
      this.objDetalhes.quantidade = produto.quantidade;
      this.objDetalhes.idProduto = produto.produto.id;
      this.objDetalhes.objProduto = produto.produto;
      this.objDetalhes.toggleModal = true;
      this.$emit("modificaDetalhes", this.objDetalhes);
    },
    calcAdicional(produto) {
      let valorAdicional = 0;

      if (produto && produto.categoriaModificadorList) {
        produto.categoriaModificadorList.forEach((el) => {
          el.produtoModificadorList.forEach((pr) => {
            valorAdicional += pr.valorUnitario + pr.valorFreteAdicional;
          });
        });
      }

      return valorAdicional;
    },
    atualizarItensCarrinho(pedido) {
      apiService
        .atualizarItensCarrinho(pedido)
        .then((response) => {
          if (response) {
            this.$store.state.pedido.itens = response.itens;
            this.setPedidoToLocalStorage(response);
            this.loading = false;
          }
        })
        .catch(() => (this.loading = false));
    },
    atualizarItensCarrinhoByToken(pedido, token) {
      apiService
        .atualizarItensCarrinhoByToken(pedido, token)
        .then((response) => {
          if (response) {
            this.$store.state.pedido.itens = response.itens;
            localStorage.setItem("carrinho", JSON.stringify(response));
          }

          this.loading = false;
        })
        .catch(() => (this.loading = false));
    },
    setPedidoToLocalStorage(pedido) {
      this.$store.state.pedido.itens = [];
      this.$store.state.pedido.valorTotal = 0;
      this.$store.state.pedido.valorFrete = 0;
      this.$store.state.pedido.valorCompra = 0;
      this.$store.state.pedido.valorDesconto = 0;
      this.$store.state.pedido.id = null;

      if (pedido && pedido.status === "AGUARDANDO_CHECKOUT") {
        this.$store.state.pedido.itens = pedido.itens;
        this.$store.state.pedido.valorTotal = pedido.valorTotal;
        this.$store.state.pedido.valorFrete = pedido.valorFrete;
        this.$store.state.pedido.valorCompra = pedido.valorCompra;
        this.$store.state.pedido.valorCompra = pedido.valorDesconto;
        this.$store.state.pedido.id = pedido.id;
      }

      setTimeout(() => {
        localStorage.setItem(
          "carrinho",
          JSON.stringify(this.$store.state.pedido)
        );
      }, 500);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.loading {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  left: 0;
  top: 0;
  z-index: 99;
}

.caixa_carrinho {
  padding: 1rem;
  background: #f6f6f6;
  z-index: 7;
  position: relative;

  .titulo_carrinho {
    font-weight: 600;
    font-size: 1.3em;
  }

  .box_carrinho {
    border: 1px solid #c1c6c8;
    padding: 0.8rem;
  }

  .carrinho_vazio {
    padding: 0.8rem 0;
  }

  .carrinho_cheio {
    .item_venda {
      border-top: 1px solid #c1c6c8;
      padding-top: 1rem;

      &:first-child {
        border-top: 0px;
        padding-top: 0rem;
      }

      .descricao {
        width: 100%;
        padding-right: 1rem;
      }

      .cat_relogio {
        max-width: 130px;

        img {
          width: 120px;
          height: auto;
          padding-right: 0.8rem;
        }
      }

      .opcoes {
        padding-left: 0.4rem;
        padding-right: 0.4rem;

        a {
          display: block;
          margin: 1rem 0;
        }
      }

      span {
        display: block;
      }
    }
  }

  .descricao {
    .item_quantidade {
      font-weight: 700;
      color: #1d4f91;
    }

    .item_valor {
      font-weight: 700;
      color: #707070;
      font-size: 1.3em;
    }
  }

  .check_out {
    .total .valor {
      font-weight: 700;
      color: #707070;
      font-size: 1.4em;
    }

    .btn_fecharpedido {
      color: #fff;
      border: 1px solid #5b6770;
      background-color: #5b6770;
      display: block;
      width: 100%;
      padding: 0.6rem;
      text-align: center;
      text-transform: uppercase;
      margin-top: 1rem;
    }
  }

  .custom-input-number button {
    width: 35px;
    height: 35px;
    background-color: #fff;
    color: #757575;
    border: 1px solid #757575;
    border-radius: 50px;
    font-size: 1.2em;
    font-weight: 800;

    &:disabled {
      color: #ccc;
      border-color: #ccc;
    }
  }
}
</style>
